import React from "react";
import styles from "./InputRadio.module.scss";
import clsx from "clsx";

export interface InputRadioProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  position?: "Left" | "Right";
  width?: "auto" | "full";
}

const InputRadioBase: React.ForwardRefRenderFunction<
  HTMLInputElement,
  InputRadioProps
> = ({ position = "Left", width = "auto", children, ...inputProps }, ref) => {
  const label = <label htmlFor={inputProps.id}>{children}</label>;

  return (
    <div
      className={clsx(styles.inputRadio, {
        [styles.positionLeft]: position == "Left",
        [styles.positionRight]: position == "Right",
        [styles.widthFull]: width == "full",
        [styles.disabled]: inputProps.disabled
      })}
    >
      {position == "Right" ? label : ""}
      <input type="radio" ref={ref} {...inputProps} />
      {position == "Left" ? label : ""}
    </div>
  );
};

export const InputRadio = React.forwardRef(InputRadioBase);
